import { useEffect, useState } from 'react';
import { Barcode, Plus, Trash } from '@phosphor-icons/react';
import styled from 'styled-components';
import { SkupremeModal } from '../../components';
import {
  DangerBorderButton,
  HoverBorderButton,
  StyledButton,
  StyledInput,
} from '../../elements';
import { CommonUtility, ItemService, theme, ToastMessage } from '../../utility';

const BarcodesContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  margin-bottom: 10px;
`;

const BarcodeIcon = styled(Barcode)`
  position: absolute;
  top: 7px;
  left: 7px;
`;

const ShadedContainer = styled.div`
  background: ${({ theme }) => theme.colors.box};
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 10px;
  justify-content: center;
  align-items: center;
  display: flex;
  height: 60px;
`;

export function EditBarcodeIdentifiers({ item, open, onClose, refresh }) {
  const [codes, setCodes] = useState([]);
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    if (CommonUtility.isValidArray(item?.product?.barcode_identifiers)) {
      setCodes(
        item?.product?.barcode_identifiers?.map(code => ({
          code,
          _id: CommonUtility.generateRandomId(),
        })),
      );
    } else {
      setCodes([]);
    }
  }, [item]);

  const addIdentifier = () => {
    setCodes([
      ...codes,
      {
        code: '',
        _id: CommonUtility.generateRandomId(),
      },
    ]);
  };

  const changeValue = (index, value) => {
    const newCodes = [...codes];
    newCodes[index].code = value;
    setCodes(newCodes);
  };

  const deleteCode = index => {
    const newCodes = [...codes];
    newCodes.splice(index, 1);
    setCodes(newCodes);
  };

  const saveIdentifiers = async () => {
    try {
      setSaving(true);
      const paylaod = {
        barcode_identifiers: codes?.map(barcode => barcode.code),
      };
      await ItemService.updateIdentifiers(item?._id, paylaod);
      ToastMessage.success('Identifiers updated successfully');
      onClose();
      refresh();
    } catch (error) {
      ToastMessage.apiError(error);
    } finally {
      setSaving(false);
    }
  };

  return (
    <SkupremeModal
      open={open}
      onClose={onClose}
      title="Edit Barcode Identifiers"
      size="tiny"
    >
      {CommonUtility.isValidArray(codes) ? (
        <BarcodesContainer>
          {codes?.map((barcode, index) => (
            <div key={barcode?._id} className="d-flex align-items-center">
              <StyledInput
                className="w-100 similar-height"
                iconPosition="left"
                value={barcode?.code}
                onChange={e => changeValue(index, e.target.value)}
              >
                <BarcodeIcon color={theme.colors.grey} size={24} />
                <input />
              </StyledInput>
              <DangerBorderButton
                onClick={() => deleteCode(index)}
                className="px-2 flex-btn ml-2"
              >
                <Trash size={20} />
              </DangerBorderButton>
            </div>
          ))}
        </BarcodesContainer>
      ) : (
        <ShadedContainer>
          <span>No Identifier(s)</span>
        </ShadedContainer>
      )}
      <HoverBorderButton onClick={addIdentifier} className="flex-btn mb-4">
        <Plus className="mr-1" />
        New Identifier
      </HoverBorderButton>
      <div className="d-flex justify-content-end">
        <HoverBorderButton disabled={saving} onClick={onClose}>
          Cancel
        </HoverBorderButton>
        <StyledButton loading={saving} onClick={saveIdentifiers} className="ml-2">
          Confirm
        </StyledButton>
      </div>
    </SkupremeModal>
  );
}
